<nav class="ft-appmenu"
     [hidden]="!(visibility$ | async)"
     (clickOutside)="hideAppMenu()">
    <button class="ft-btn-close" (click)="hideAppMenu()"></button>

    <div class="ft-userid pointer" *ngIf="(user$ | async) as user">
        <div class="v-center" (click)="goToProfile()">
            <ft-user-profile-image [user]="user" class="mr-3" />
            <span class="ft-username">{{ user | fullName }}</span>
        </div>
        <button *ngIf="user.isImpersonating" (click)="unimpersonate()">Unimpersonate</button>
    </div>

    <div class="ft-spaceid" *ngIf="(spaces$ | async)?.allSpaces.length > 1" (click)="showSpacesComponent()">
        <span class="ft-spacename" *ngIf="spaceService.current">{{ spaceTitle }}</span>
        <span class="ft-switchspace">Switch</span>
    </div>

    <ul class="ft-area-links">
        <!--        <li class="ft-navitem ft-navitem-divider" *ngIf="area?.divider"></li>-->


        <ng-container *ftCheckSpaceType="'Collaborative'">
            <ng-container *ftAreas="let areas=areas; let isActive=isActive; let invoke=invoke;registryName:'AppMenuAreasRegistry'">
                <ng-container *ngFor="let area of areas | orderBy: 'order'" >
                    <li [class]="area.$class"
                        [ftDisabled]="area.isDisabled"
                        [ngClass]="{active: isActive(area)}">
                        <!-- Primary -->
                        <ng-container *ngIf="area.state">
                            <a [uiSref]="area.state" [uiParams]="area.stateParams" (click)="hideAppMenu()">{{area.name}}</a>
                        </ng-container>

                        <!-- More -->
                        <ng-container *ngIf="area.options">
                            <ul>
                                <li *ngFor="let option of area.options | orderBy: 'order'" [class]="option.$class" [ngClass]="{active: isActive(option)}"
                                    [ftDisabled]="option.isDisabled">
                                    <a *ngIf="option.state" [uiSref]="option.state" [uiParams]="option.stateParams">{{option.name}}</a>
                                    <a *ngIf="option.handler" (click)="hideAppMenu(); invoke($event, option.handler)">{{option.name}}</a>
                                </li>
                            </ul>
                        </ng-container>
                    </li>
                    <li class="ft-navitem ft-navitem-divider" *ngIf="area?.divider"></li>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ftCheckSpaceType="['Company', 'Mixed', 'Property']">
            <li class="ft-navitem" [uiSref]="'hub'"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>Overview</a>
            </li>
            <li *ftCheckSpaceType="['Property', 'Mixed']"
                class="ft-navitem"
                [uiSref]="'advocacy.big-picture'"
                [uiParams]="spaceAttributes">
                <a>Advocacy</a>
            </li>
            <li class="ft-navitem"
                [uiSref]="'discovery'"
                [uiParams]="spaceAttributes">
                <a>Discovery</a>
            </li>
            <ng-container *ftCheckLicense="'Spacetime'; forceShow: isFliptoStaff">
                <ng-container *ftCheckSpaceType="['Property', 'Company', 'Mixed']">
                    <li *ngIf="!isSpacetimeDisabled; else spacetimeSideUnavailable"
                        class="ft-navitem"
                        [uiSref]="'spacetime'"
                        [uiParams]="spaceAttributes">
                        <a class="d-flex">
                            Spacetime
                            <span *ngIf="isSpacetimeFliptoOnly" class="ml-auto mr-2">
                                <mat-icon svgIcon="lock" class="icon-xs mr-1" />
                                <strong>For Flip.to only</strong>
                            </span>
                        </a>
                    </li>
                    <ng-template #spacetimeSideUnavailable>
                        <li class="ft-navitem" style="cursor: not-allowed;">
                            <a>Spacetime</a>
                        </li>
                    </ng-template>
                </ng-container>
            </ng-container>

            <ng-container *ftCheckSpaceType="['Property', 'Mixed']">
                <ng-container  *ngIf="isLocalLicenseActive || isLocalLicenseActive">
                    <li class="ft-navitem ft-navitem-divider"></li>
                </ng-container>
            </ng-container>

            <li class="ft-navitem"
                *ftCheckSpaceType="['Property', 'Mixed']"
                uiSref="stories.photos"
                [uiParams]="spaceAttributes"
                uiSrefActive="active">
                <a>Traveler stories</a>
            </li>
            <li class="ft-navitem" *ngIf="isLocalLicenseActive"
                [uiSref]="'experiences.org'"
                [uiParams]="spaceAttributes"
                uiSrefActive="active">
                <a>Experiences At {{ company?.Name || property?.Name }}</a>
            </li>
            <li class="ft-navitem" *ngIf="isOGLicenseActive"
                [uiSref]="'experiences.vendor'"
                [uiParams]="spaceAttributes"
                uiSrefActive="active">
                <a>Local events from occasiongenius</a>
            </li>
            <li class="ft-navitem" *ftCheckSpaceType="['Property', 'Mixed']"
                [uiSref]="'people.directory'"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>
                    People
                </a>
            </li>

            <li class="ft-navitem ft-navitem-divider"></li>

            <li class="ft-navitem" *ftCheckSpaceType="['Property', 'Mixed']" [uiSref]="'mission-control.details'"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>Mission Control</a>
            </li>
            <li class="ft-navitem" *ftCheckSpaceType="['Property', 'Mixed']" [uiSref]="'incentives'"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>Incentives</a>
            </li>
            <li class="ft-navitem" [uiSref]="'reports'" [uiParams]="spaceAttributes" [uiSrefActive]="'active'">
                <a>Reports</a>
            </li>
            <li class="ft-navitem" *ftCheckSpaceType="['Company', 'Mixed', 'Collaborative']" [uiSref]="'team'"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>Team</a>
            </li>
            <li class="ft-navitem" *ftCheckSpaceType="['Company', 'Mixed']" [uiSref]="'domains'"
                ftPermissions="DomainsRead"
                [uiSrefActive]="'active'"
                [uiParams]="spaceAttributes">
                <a>Domains</a>
            </li>
            <li class="ft-navitem" *ftCheckSpaceType="['Company', 'Mixed']" [uiSref]="'account-settings'" [uiParams]="spaceAttributes"  [uiSrefActive]="'active'">
                <a>Account Settings</a>
            </li>
        </ng-container>
    </ul>

    <ul class="ft-appmenu-links">
        <!-- Permanent appmenu links -->
        <li class="ft-navitem">
            <a (click)="signOut()">Sign out</a>
        </li>
    </ul>

    <!-- <ft-notifications>
    </ft-notifications> -->
</nav>
